import { render, staticRenderFns } from "./layout-category-page.vue?vue&type=template&id=fa171ea0&scoped=true&"
import script from "./layout-category-page.vue?vue&type=script&lang=js&"
export * from "./layout-category-page.vue?vue&type=script&lang=js&"
import style0 from "./layout-category-page.vue?vue&type=style&index=0&id=fa171ea0&lang=scss&scoped=true&"
import style1 from "./layout-category-page.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa171ea0",
  null
  
)

export default component.exports